module.exports = __webpack_public_path__ + "static/img/icon3-12.3b371307.png";